import { Children } from 'react';

export const grouper = (children) => {
  let result = {};
  let key;
  Children.forEach(children, (child) => {
    if (child === null) return;
    key = child.type.name;
    if (!(key in result)) {
      result[key] = []
    }
    result[key].push(child)
  })
  return result
}

